import { Info } from 'lucide-react'
import type { Member } from '@/features/members/types/member'
import { Badge } from '@/components/custom/badge'
import { Button } from '@/components/ui/button'
import { formatPhone } from '@/utils/inputFormat'

interface MemberCardProps {
  member: Member
  churchName: string
  onDetail: (memberId: string) => void
}

export function MemberCard({ member, churchName, onDetail }: MemberCardProps) {
  return (
    <div className="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-lg">{member.name}</div>
        <Badge color={member.active ? 'green' : 'gray'}>
          {member.active ? 'Active' : 'Inactive'}
        </Badge>
      </div>

      <div className="space-y-2 mb-4">
        <div className="text-sm">
          <span className="font-medium text-gray-600">Email: </span>
          <span>{member.email}</span>
        </div>
        {member.phone && (
          <div className="text-sm">
            <span className="font-medium text-gray-600">Phone: </span>
            <span>{formatPhone(member.phone)}</span>
          </div>
        )}
        <div className="text-sm">
          <span className="font-medium text-gray-600">Church: </span>
          <span>{churchName}</span>
        </div>
      </div>

      <Button
        variant="outline"
        size="sm"
        className="w-full"
        onClick={() => onDetail(member._id)}
      >
        <Info className="h-4 w-4 mr-2" /> Details
      </Button>
    </div>
  )
}
